import React from "react";

const StockCreateCategoryScreen = () => {
  return <div>StockCreateCategoryScreen</div>;
};

export default StockCreateCategoryScreen;
